// ── 달력 탭 필터 버튼 (2026-09-29 사용자 그림 — 상세 탭 필터와 같은 모양) ──────────────────
//   예전 달력 위의 [전체 부서][전체 상태] 칸 두 개를 이 버튼 안으로 옮겼다(사용자 확정 "부서·상태 고르기").
//   고르면 버튼에 개수와 X(초기화)가 붙는다 — 상세 탭 AttendanceFilterPopover 와 같은 규칙·모양.
//   차단형 모달 아님(드롭다운) — 스크롤 잠금 없이 투명 클릭아웃으로 닫는다.
//   통합 메뉴면 맨 위에 "회사" 칸(companyFilter, 2026-09-30 — 제목 아래 칩을 이 안으로).
import React, { useState } from 'react';
import { Filter, X } from 'lucide-react';
import { STATUS_META } from './utils';
import { inputStyle } from '../attendancemgmt/styles';
import { stdBlackBtn } from '../adminlayout/designStandard';
import { CompanyFilterField, companyFilterActive, companyFilterUsable, resetCompanyFilter } from '../attendancehub/CompanyFilterField';

export function CalendarFilterPopover({
  isMobile, departments = [],
  filterDept, setFilterDept, filterStatus, setFilterStatus,
  companyFilter = null,
}) {
  const [open, setOpen] = useState(false);
  const activeCount = (filterDept ? 1 : 0) + (filterStatus ? 1 : 0) + (companyFilterActive(companyFilter) ? 1 : 0);

  function resetFilters() {
    setFilterDept('');
    setFilterStatus('');
    resetCompanyFilter(companyFilter);
    setOpen(false);
  }

  return (
    <div style={{ position: 'relative', flexShrink: 0 }}>
      <button
        type="button"
        style={{
          ...stdBlackBtn, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
          height: 40, width: activeCount > 0 ? 'auto' : 44, padding: activeCount > 0 ? '0 12px' : 0,
        }}
        onClick={() => setOpen((v) => !v)}
        aria-label="필터"
        title={companyFilterUsable(companyFilter) ? '필터 (회사·부서·상태)' : '필터 (부서·상태)'}
      >
        <Filter size={16} />
        {activeCount > 0 && (
          <>
            <span style={{ fontSize: 13, fontWeight: 800 }}>{activeCount}</span>
            {/* X = 필터 초기화 — 버튼 안의 중첩 클릭이라 팝오버 토글로 번지지 않게 차단 */}
            <span
              role="button"
              aria-label="필터 초기화"
              title={companyFilterUsable(companyFilter) ? '필터 초기화 (전체 회사·전체 부서·전체 상태)' : '필터 초기화 (전체 부서·전체 상태)'}
              onClick={(e) => { e.stopPropagation(); resetFilters(); }}
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18,
                borderRadius: 6, background: 'rgba(255,255,255,0.22)', cursor: 'pointer',
              }}
            >
              <X size={12} />
            </span>
          </>
        )}
      </button>
      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 900 }} onClick={() => setOpen(false)} />
          <div style={{
            position: 'absolute', top: 46, right: isMobile ? 0 : 'auto', left: isMobile ? 'auto' : 0,
            zIndex: 901, width: 240, background: 'var(--bg-card)', border: '1px solid var(--border)',
            borderRadius: 12, boxShadow: '0 12px 32px rgba(15,27,53,0.14)', padding: 14,
            display: 'grid', gap: 10,
          }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: 'var(--text)' }}>필터</div>
            <CompanyFilterField companyFilter={companyFilter} />
            <select aria-label="부서" style={inputStyle} value={filterDept} onChange={(e) => setFilterDept(e.target.value)}>
              <option value="">전체 부서</option>
              {departments.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
            <select aria-label="상태" style={inputStyle} value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
              <option value="">전체 상태</option>
              {Object.entries(STATUS_META).map(([code, meta]) => (
                <option key={code} value={code}>{meta.label}</option>
              ))}
            </select>
          </div>
        </>
      )}
    </div>
  );
}
